import { css } from '@emotion/react'
import {
  HeaderMedium500Style,
  InfoMedium600Style,
  InfoMedium500Style,
} from '../../../styles/Text.styles'

export const DataVariablePresentation = css`
  ${HeaderMedium500Style}
`

export const DataVariableLabel = css`
  ${InfoMedium600Style}
`

export const DataValueLabel = css`
  ${InfoMedium500Style}
`
